import * as patterns from 'utils/pattern-initializer';

const aConditionalRequirements = [];

// needed for utilities/components and components/pages
if (!document.body.dataset) {
	aConditionalRequirements.push('../polyfills/element-dataset');
}

// needed for components/pages
if (!document.body.closest) {
	aConditionalRequirements.push('../polyfills/element-closest');
}

// needed for components/pages
if (!window.fetch) {
	aConditionalRequirements.push('../polyfills/window-fetch');
}

if (!window.Promise) {
	aConditionalRequirements.push('../polyfills/promise');
}

if (typeof window.CustomEvent !== 'function') {
	aConditionalRequirements.push('../polyfills/custom-event');
}

if (!window.Symbol) {
	aConditionalRequirements.push('../polyfills/symbol');
}

if (!window.IntersectionObserver) {
	aConditionalRequirements.push('../polyfills/intersection-observer');
}

if (typeof Blob === 'function' && (typeof FormData === 'undefined' || !FormData.prototype.keys)) {
	aConditionalRequirements.push('../polyfills/form-data');
}

if (window.NodeList && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = Array.prototype.forEach;
}

if (/^function|object$/.test(typeof URL) && !(URL.prototype)) {
	// https://github.com/jerrybendy/url-search-params-polyfill
	aConditionalRequirements.push('../polyfills/url-search-params');
}

if (typeof HTMLTemplateElement === 'undefined') {
	// https://github.com/webcomponents/template
	aConditionalRequirements.push('../polyfills/template');
}

// eslint-disable-next-line
require(aConditionalRequirements, () => {
	patterns.initialize((sPatternName, fnLoadCallback) => {
		// eslint-disable-next-line global-require
		require([sPatternName], fnLoadCallback); // eslint-disable-line import/no-dynamic-require
	});
});
